<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
      </ul>
      <div class="copyright">
        &copy; {{ year }}, Powered by
        <a href="https://vectolabs.com" target="_blank">Vectolabs Technologies Sdn Bhd</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
